import { useRef, useMemo } from "react";

import { DIRECTION_X, DIRECTION_Y, ITEM_INDEX_PROP } from "./constants";

const SlideItem = ({
  item,
  index,
  realIndex,
  isCurrent,
  isClone,
  renderItem,
  direction,
  offset
}) => {
  const ref = useRef(null);
  return useMemo(
    () =>
      renderItem({
        item,
        index,
        realIndex,
        isCurrent,
        isClone,
        getItemProps: ({ style = {}, ...rest } = {}) => ({
          ...rest,
          style: {
            ...style,
            position: "absolute",
            left: direction === DIRECTION_X && offset ? offset : 0,
            top: direction === DIRECTION_Y && offset ? offset : 0
          },
          [ITEM_INDEX_PROP]: index,
          ref
        })
      }),
    [offset, item, index, realIndex, isCurrent, direction, renderItem, isClone]
  );
};

export default SlideItem;
